class EventEmitter {
	events = {};

	_getEventListByName(eventName: string) {
		if (typeof this.events[eventName] === 'undefined') {
			this.events[eventName] = new Set();
		}
		return this.events[eventName];
	}

	on(eventName: string, fn: (params?: any) => void) {
		this._getEventListByName(eventName).add(fn);
	}

	once(eventName: string, fn: (params?: any) => void) {
		const onceFn = (...args: [args?: any]) => {
			this.removeListener(eventName, onceFn);
			fn.apply(this, args);
		};
		this.on(eventName, onceFn);
	}

	emit(eventName: string, ...args) {
		this._getEventListByName(eventName).forEach((fn => fn.apply(this, args)).bind(this));
	}

	removeListener(eventName: string, fn: (params?: any) => void) {
		this._getEventListByName(eventName).delete(fn);
	}
}

class FuseUtils {
	static EventEmitter = EventEmitter;
}

export default FuseUtils;
